import $ from 'jquery';
import './debug';
import 'select2';
// import 'jquery-match-height';
import './vendors/biggerlink';
import './vendors/matchHeight';
import './vendors/jquery.fancybox';
//
$(document).ready(function () {
	//select2

	$('.customSelect').select2({
		placeholder: "選択してください",
	});
	$('.jsNavTitleBoder a').on('click', function (e) {
		if ($(this).parent('li').hasClass('active')) {
			$('.jsNavTitleBoder').removeClass('active');
		} else {
			$('.jsNavTitleBoder').removeClass('active');
			$(this).parent('li').addClass('active');
		}
		e.preventDefault();
	});

	// Biggerlink
	$('.blockNextPrev div').biggerlink();
	$('.relatedLink li').biggerlink();

	function setCookie(cname, cvalue, exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires=" + d.toGMTString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	function checkCookie() {
		var fontSize = getCookie('fontSize');
		if (fontSize == 'zoom') {
			$('body').addClass('zoom');
			$('.jsChangeFontSize').prop('checked', true);
		} else {
			$('body').removeClass('zoom');
			$('.jsChangeFontSize').prop('checked', false);
		}
	}
	checkCookie();
	$('.jsChangeFontSize').on('change', function (e) {
		if ($('.jsChangeFontSize').is(':checked')) {
			setCookie('fontSize', 'zoom', 1000);
			$('body').addClass('zoom');
		} else {
			setCookie('fontSize', '', 1000);
			$('body').removeClass('zoom');
		}
	});

	$('.jsToolbarFontSize span').on('click', function (e) {
		if ($(this).data('type') == 'zoom') {
			$('body').addClass('zoom');
			$('.jsChangeFontSize').prop('checked', true);
		} else {
			$('body').removeClass('zoom');
			$('.jsChangeFontSize').prop('checked', false);
		}
		e.preventDefault();
	});
	//
	if ($('.overlay').length) {
		const $overlay = $('.overlay');
		const $jsNavBtn = $('.jsNavBtn');
		const $headerToolbarLi = $('.subNav').siblings('.toolbarBtn').parent();
		//
		$headerToolbarLi.on('click touch', function(event) {
			$overlay.addClass('active');
			$jsNavBtn.removeClass('active');
			$('.jsNav').removeClass('active');
		});
		//
		$('.subNav').parent().on('mouseover', function(event) {
			if (window.innerWidth > 992) {
				$overlay.addClass('active');
			}
		}).on('mouseleave', function(event) {
			if (window.innerWidth > 992) {
				$overlay.removeClass('active');
			}
		});
		//
		let curDevideWidth = window.innerWidth;
		$(window).on('resize', function(event) {
			if (curDevideWidth != window.innerWidth) {
				curDevideWidth = window.innerWidth;
				// De-active subNav
				if ($jsNavBtn.hasClass('active')) {
					console.info('==========================');
					$jsNavBtn.removeClass('active');
					$('.jsNav').removeClass('active');
					$overlay.removeClass('active');
				}
			}
		});
		//
		if ($('#header .buttonAccordion').length) {
			const $buttonAccordion = $('#header .buttonAccordion');
			$buttonAccordion.on('click', function(event) {
				$(this).toggleClass('active');
				$(this).siblings('.subNav').slideToggle();
			});
		}
		//
		$jsNavBtn.on('click', function (e) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$('.jsNav').removeClass('active');
				$overlay.removeClass('active');
			} else {
				$(this).addClass('active');
				$('.jsNav').addClass('active');
				$overlay.addClass('active');
			}
			e.preventDefault();
		});
		$overlay.on('click touch', function(event) {
			$jsNavBtn.removeClass('active');
			$('.jsNav').removeClass('active');
			$overlay.removeClass('active');
		});
	}
	$('.biggerlink .itemLink').biggerlink();

	//Accordion

	$(".plusProduct").click(function () {
		var itemLine = 5;
		var elm = $(this);
		var totalHeight = 0;
		$.fn.matchHeight._update();
		if (elm.hasClass('active')) {
			elm.removeClass("active");
			$(".listProduct").css({
				'height': $(".listProduct li").height() + 18
			});
			elm.children("span").html("さらに表示する").removeClass("close");
		} else {
			if ($(window).width() < 736) {
				itemLine = 3;
				$.fn.matchHeight._update();
			}
			elm.addClass("active");
			var numLine = Math.ceil($(".listProduct").children().length / itemLine);
			// getAtt(numLine,itemLine);
			for (let i = 0; i < numLine; i++) {
				var hEachLine = $(".listProduct").children('li:nth-child(' + (i * itemLine + 1) + ')').height();
				totalHeight += hEachLine;
			}
			$(".listProduct").css({
				'height': totalHeight + 50
			});
			elm.children("span").html("閉じる").addClass("close");
		}
	});


	setTimeout(function () {
		$.fn.matchHeight._update();
		$(".listProduct").css({
			'height': $(".listProduct li").height() + 18
		});

	}, 500);

	function getAtt(numLine, itemLine) {
		var count = 1;
		for (let i = 1; i <= numLine; i++) {
			for (let j = 1; j <= itemLine; j++) {
				if (count === $(".listProduct").children().length + 1) {
					return;
				}
				$('.listProduct').children("li:nth-child(" + (count) + ")").children('h3').attr("data-mh", "child0" + i + "");
				count++;
			}
		}
	}
	$('.listProduct li').matchHeight({
		byRow: true,
	});
	$('[data-fancybox="ajax"]').fancybox({
		arrows: true,
		loop: true,
		btnTpl: {
			arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
				'<img src="/assets/img/common/icon_arrow_left.svg">' +
				"</button>",

			arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
				'<img src="/assets/img/common/icon_arrow_right01.svg">' +
				"</button>"
		},
		afterShow: function (instance, current) {
			var offset = $(current.src).offset();
			$('.fancybox-button--arrow_left').css({
				left: offset.left - 75
			});
			$('.fancybox-button--arrow_right').css({
				right: offset.left - 75
			});
		}
	});
	$('.anchor a').click(function (e) {
		var anchorLink = $(this).attr('href');
		if (anchorLink != '#') {
			var offTop = $(anchorLink).offset().top;
			$('body, html').stop().animate({
				scrollTop: offTop
			}, 200);
		}
		return false;
	});
	// PageTop
	$(".pageTop a").click(function () {
		$("html, body").animate({
			scrollTop: 0
		});
		return false;
	});
	// pageTop position
	if ($('.pageTop').length) {
		var $pageTop = $(".pageTop");
		var pageTopBottom = parseInt($pageTop.css('bottom'));
		$(window).on('load resize', function () {
			$pageTop.css({
				position: '',
				bottom: ''
			});
			pageTopBottom = parseInt($pageTop.css('bottom'));
			$(window).trigger('scroll');
		});
		$(window).on('scroll', function (event) {
			if ($(window).scrollTop() > $('#header').height()) {
				$pageTop.addClass('active');
				var $scrollTop = $('html').scrollTop(),
					$posFooter = $("#footer").position();
				if($scrollTop+$(window).height() >= $posFooter.top) {
					if($(window).width()<=736) {
						$pageTop.css({
							position: 'absolute',
							bottom: $("#footer").outerHeight() + 45 + 'px'
						});
					}else{
						$pageTop.css({
							position: 'absolute',
							bottom: $("#footer").outerHeight() + 60 + 'px'
						});
					}
				}else{
					if($(window).width()<=736) {
						$pageTop.css({
							position: 'fixed',
							bottom: '20px'
						});
					}else{
						$pageTop.css({
							position: 'fixed',
							bottom: '27px'
						});
					}
				}
			} else {
				$pageTop.removeClass('active');
			}
		});
	}


});